export const shellCard = 'rounded-2xl border border-[rgba(var(--border),0.55)] bg-[rgba(var(--panel),0.84)] shadow-[0_18px_40px_rgba(var(--shadow),0.12)]';
export const fieldClass = 'mt-1 w-full rounded-xl border border-[rgba(var(--border),0.7)] bg-[rgba(var(--subpanel),0.35)] px-3 py-2 text-sm text-[rgb(var(--fg))] outline-none transition placeholder:text-[rgba(var(--muted),0.75)] focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]';
export const buttonClass = 'inline-flex items-center justify-center rounded-xl border border-[rgba(var(--border),0.55)] bg-[rgba(var(--subpanel),0.3)] px-3 py-2 text-sm font-semibold text-[rgb(var(--fg))] transition hover:bg-[rgba(var(--subpanel),0.55)] focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]';
export const primaryButtonClass = 'inline-flex items-center justify-center rounded-xl bg-[rgb(var(--brand))] px-3 py-2 text-sm font-semibold text-[rgb(var(--bg))] transition hover:bg-[rgb(var(--brand-700))] focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]';

export const money = (value) =>
  new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' }).format(Number(value || 0));

export const parseJsonSafe = (value) => {
  if (!value) return null;
  try {
    return typeof value === 'string' ? JSON.parse(value) : value;
  } catch {
    return null;
  }
};

export function LabeledField({ label, hint, children, span = 'col-span-12 md:col-span-6 lg:col-span-4' }) {
  return (
    <label className={`${span} block text-sm`}>
      <span className="font-medium text-[rgb(var(--fg))]">{label}</span>
      {hint ? <span className="mt-0.5 block text-xs text-[rgba(var(--muted),0.95)]">{hint}</span> : null}
      {children}
    </label>
  );
}
